import { FC } from 'react';
import { Edit } from 'react-admin';
import { ChangeFileForm } from '../../../../widgets/ChangeFileForm/ui/ChangeFileForm';

export const FileEdit: FC = () => (
  <Edit>
    <ChangeFileForm />
  </Edit>
);
